import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import YouTube from 'react-youtube';
import './CompanyVideos.css';

const CompanyVideos = () => {
  const { translate } = useTranslation();

  // YouTube video options
  const opts = {
    height: '390',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  // Featured YouTube video IDs - replace these with your actual video IDs
  const featuredVideos = [
    { id: 'N5P3Yt6lNBo', title: translate('about.companyVideos.videoSection.video1Title') },
    { id: 'I_3lq4-eJjM', title: translate('about.companyVideos.videoSection.video2Title') },
  ];

  return (
    <div className="company-videos-page">
      <section className="company-videos-header">
        <h2>{translate('about.companyVideos.preTitle')}</h2>
        <h1>{translate('about.companyVideos.title')}</h1>
        <p>{translate('about.companyVideos.subtitle')}</p>
      </section>

      <section className="company-videos-content">
        <div className="featured-videos-section">
          <h2>{translate('about.companyVideos.featuredSection.title')}</h2>
          <p>{translate('about.companyVideos.featuredSection.description')}</p>

          <div className="video-grid">
            {featuredVideos.map((video, index) => (
              <div className="video-wrapper" key={index}>
                <h3>{video.title}</h3>
                <YouTube videoId={video.id} opts={opts} className="youtube-video" />
              </div>
            ))}
          </div>
        </div>

        <div className="more-videos-section">
          <h2>{translate('about.companyVideos.moreVideosSection.title')}</h2>
          <p>{translate('about.companyVideos.moreVideosSection.description')}</p>

          <div className="rednote-link-container">
            <a
              href={translate('about.companyVideos.moreVideosSection.rednoteLink')}
              target="_blank"
              rel="noopener noreferrer"
              className="rednote-link"
            >
              {translate('about.companyVideos.moreVideosSection.rednoteLinkText')}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CompanyVideos;
